export const baseFields = [
  {
    value: 'clicks',
    label: 'Клики',
    marker: '#007AFF',
    subColor: 'rgba(0, 122, 255, 5%)',
    subItems: [
      {
        value: 'count_clicks',
        label: 'Кол-во',
        color: '#007AFF',
        subColor: 'rgba(0, 122, 255, 5%)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {value: 'click2lead', label: 'Click2Lead', type: 'conversion', sort: true},
      {
        value: 'click2appeal',
        label: 'Click2Chat',
        type: 'conversion',
        clue: 'Конверсия из клика в чат',
        sort: true,
      },
      {
        value: 'click2reg',
        label: 'Click2Reg',
        type: 'conversion',
        clue: 'Конверсия из клика в регистрацию',
        sort: true,
      },
      {
        value: 'click2fd',
        label: 'Click2Fd',
        type: 'conversion',
        clue: 'Конверсия из клика в первый депозит',
        sort: true,
      },
      {
        value: 'click2cpa',
        label: 'Click2Cpa',
        type: 'conversion',
        clue: 'Конверсия из клика в квалификацию',
        sort: true,
      },
      {
        value: 'click2rs',
        label: 'Click2Rs',
        type: 'conversion',
        sort: true,
      },
      {
        value: 'cpc',
        label: 'CPC',
        label_large: 'CPC (Cost Per Click)',
        fontWeight: 'bold',
        type: 'cash',
        clue: 'Стоимость за клик',
        sort: true,
      },
    ],
  },
  {
    value: 'leads',
    label: 'Лиды',
    marker: '#5856D6',
    subColor: 'rgba(88, 86, 214, 5%)',
    subItems: [
      {
        value: 'count_leads',
        label: 'Кол-во',
        color: '#5856D6',
        subColor: 'rgba(88, 86, 214, 5%)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {
        value: 'lead2appeal',
        label: 'Lead2Chat',
        type: 'conversion',
        clue: 'Конверсия лидов в чат',
        sort: true,
      },
      {
        value: 'lead2reg',
        label: 'Lead2Reg',
        type: 'conversion',
        clue: 'Конверсия лидов в регистрацию',
        sort: true,
      },
      {
        value: 'lead2fd',
        label: 'Lead2Fd',
        type: 'conversion',
        clue: 'Конверсия лидов в первый депозит',
        sort: true,
      },
      {
        value: 'lead2cpa',
        label: 'Lead2Cpa',
        type: 'conversion',
        clue: ' Конверсия лидов в квалификацию',
        sort: true,
      },
      {
        value: 'lead2rs',
        label: 'Lead2Rs',
        type: 'conversion',
        sort: true,
      },
      {
        value: 'cpl',
        label: 'CPL',
        label_large: 'CPL (Cost Per Lead)',
        fontWeight: 'bold',
        type: 'cash',
        clue: 'Стоимость за лида',
        sort: true,
      },
    ],
  },
  {
    value: 'chats',
    label: 'Чаты',
    marker: '#FF2DF8',
    subColor: 'rgba(255, 45, 248, 5%)',
    subItems: [
      {
        value: 'count_appeals',
        label: 'Кол-во',
        color: '#FF2DF8',
        subColor: 'rgba(255, 45, 248, 5%)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {value: 'chat2reg', label: 'Chat2Reg', type: 'conversion', sort: true},
      {
        value: 'chat2fd',
        label: 'Chat2Fd',
        type: 'conversion',
        sort: true,
      },
      {
        value: 'chat2cpa',
        label: 'Chat2Cpa',
        type: 'conversion',
        sort: true,
      },
      {
        value: 'chat2rs',
        label: 'Chat2Rs',
        type: 'conversion',
        sort: true,
      },
      {
        value: 'cpm',
        label: 'CPM',
        label_large: 'CPM (Cost Per Chat)',
        fontWeight: 'bold',
        type: 'cash',
        sort: true,
      },
    ],
  },
  {
    value: 'registration',
    label: 'Регистрации',
    marker: '#AF52DE',
    subColor: 'rgba(175, 82, 222, 5%)',
    type: 'link',
    subItems: [
      {
        value: 'count_registrations',
        label: 'Кол-во',
        color: '#AF52DE',
        subColor: 'rgba(175, 82, 222, 5%)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {
        value: 'reg2fd',
        label: 'Reg2Fd',
        type: 'conversion',
        clue: 'Конверсия регистраций в первый депозит',
        sort: true,
      },
      {
        value: 'reg2cpa',
        label: 'Reg2Cpa',
        type: 'conversion',
        clue: 'Конверсия регистраций в квалификации',
        sort: true,
      },
      {
        value: 'reg2rs',
        label: 'Reg2Rs',
        type: 'conversion',
        clue: 'Конверсия регистраций в квалификации',
        sort: true,
      },
      {
        value: 'cpr',
        label: 'CPR',
        label_large: 'CPR (Cost Per Reg)',
        fontWeight: 'bold',
        type: 'cash',
        clue: 'Стоимость за регистрацию',
        sort: true,
      },
    ],
  },
  {
    value: 'first_deposits',
    label: 'Первые Депозиты',
    marker: '#00C7BE',
    subColor: 'rgba(0, 199, 190, 5%)',
    type: 'link',
    subItems: [
      {
        value: 'count_first_deposits',
        label: 'Кол-во',
        color: '#00C7BE',
        subColor: 'rgba(0, 199, 190, 5%)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {
        value: 'fd2cpa',
        label: 'Fd2Cpa',
        type: 'conversion',
        clue: 'Конверсия первых депозитов в квалификации',
        sort: true,
      },

      {
        value: 'cpf',
        label: 'CPFD',
        label_large: 'CPFD (Cost Per Fd)',
        fontWeight: 'bold',
        type: 'cash',
        clue: 'Стоимость за первый депозит',
        sort: true,
      },
    ],
  },
  {
    value: 'qualifications',
    label: 'Квалификации',
    marker: '#9BC734',
    subColor: 'rgba(155, 190, 52, 5%)',
    type: 'link',
    subItems: [
      {
        value: 'count_qualifications',
        label: 'Кол-во',
        color: '#9BC734',
        subColor: 'rgba(155, 190, 52, 5%)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {
        value: 'revenue_cpa',
        label: 'Сумма',
        type: 'cash',
        sort: true,
      },
      {
        value: 'cpa',
        label: 'CPA',
        label_large: 'CPA (Cost Per Action)',
        fontWeight: 'bold',
        type: 'cash',
        clue: 'Стоимость за квалификацию',
        sort: true,
      },
    ],
  },
  {
    value: 'revshare',
    label: 'RevShare',
    marker: '#ffa165',
    subColor: 'rgba(255, 161, 101, 5%)',
    type: 'link',
    subItems: [
      {
        value: 'count_rs',
        label: 'Кол-во',
        color: '#ffa165',
        subColor: 'rgba(255, 161, 101, 5%)',
        type: 'count',
        sort: true,
      },
      {
        value: 'revenue_rs',
        label: 'Сумма',
        type: 'cash',
        sort: true,
      },
      {
        value: 'cprs',
        label: 'CPRS',
        label_large: 'CPRS (Cost Per Rs)',
        fontWeight: 'bold',
        type: 'cash',
        sort: true,
      },
    ],
  },
  {
    value: 'finance',
    label: 'Финансы',
    marker: '#34C77E',
    subColor: 'rgba(52, 199, 126, 0.05)',
    subItems: [
      {
        value: 'revenue',
        label: 'Доход',
        type: 'cash',
        sort: true,
      },
      {
        value: 'cost',
        label: 'Расходы',
        type: 'cash',
        sort: true,
      },
      {
        value: 'profit',
        label: 'Прибыль',
        type: 'cash',
        fontWeight: 'bold',
        sort: true,
      },
      {
        value: 'romi',
        label: 'ROMI',
        type: 'conversion',
        colorForMore: '#34C759',
        colorForLess: '#FF3B30',
        sort: true,
      },
    ],
  },
];

export const fieldsOfGroups = [
  {
    value: 'offer',
    label: 'Оффер',
    type: 'link',
    rout: '/advertisers/offers/',
    isEditLink: '/advertisers/offers/updateOffer',
    isEdit: false,
    edit: '/advertisers/offers/',
  },
  {value: 'day', label: 'День', type: 'link'},
  {value: 'month', label: 'Месяц', type: 'link'},
  {value: 'year', label: 'Год', type: 'link'},
  {
    value: 'advertiser',
    label: 'Рекламодатель',
    type: 'link',
    rout: '/advertisers/list/',
    isEdit: false,
    isEditLink: '/advertisers/update',
    edit: '/advertisers/list/',
  },
  {value: 'brand', label: 'Бренд', type: 'link', isEdit: true, edit: '/advertisers/brands/'},
  {value: 'country', label: 'Страна', type: 'link'},
  {value: 'pwa', label: 'Приложение', type: 'link', rout: '/app/', isTimeConfig: true},
  {value: 'app', label: 'Приложение', type: 'link', rout: '/app/', isTimeConfig: true},
  {
    value: 'traffic',
    label: 'Кампания',
    type: 'link',
    rout: '/tracker/facebook/companies/',
    isFilter: true,
    isTimeConfig: true,
  },
  {value: 'bayer', label: 'Байер', type: 'link', rout: '/tracker/facebook/bayers/'},
  {
    value: 'source',
    label: 'Поток',
    type: 'link',
    rout: '/tracker/facebook/source/',
    isTimeConfig: true,
  },
  {
    value: 'finance',
    label: 'Финансы',
    marker: '#34C77E',
    type: 'link',
    rout: '/tracker/facebook/source/',
  },
  {value: 'pixel', label: 'Пиксели', type: 'link', rout: '/tracker/facebook/pixels/'},
  {value: 'landing', label: 'Лендинг', type: 'link'},
  {value: 'traffics_id', label: 'Кампания', type: 'link', rout: '/tracker/facebook/companies/'},
  {value: 'campaign', label: 'FB Campaigns', type: 'link'},
  {value: 'adset', label: 'FB Adsets', type: 'link'},
  {value: 'ad', label: 'FB Ads', type: 'link'},
  {value: 'app_type', label: 'Платформа', type: 'link', isNotSorted: true},
  {value: 'inf_source', label: 'INF Потоки', type: 'link'},
  {value: 'fb_source', label: 'FB Потоки', type: 'link'},
  {value: 'inf_bayer', label: 'Байер', type: 'link', rout: '/tracker/influence/bayers/'},
  {value: 'fb_bayer', label: 'Байер', type: 'link', rout: '/tracker/facebook/bayers/'},
  {value: 'inf_traffic', label: 'Блогер', type: 'link', rout: '/tracker/influence/bloggers/'},
  {
    value: 'fb_traffic',
    label: 'Кампания',
    type: 'link',
    rout: '/tracker/facebook/companies/',
    isTimeConfig: true,
  },
  {value: 'app_service', label: 'Сервис', type: 'link'},
  {value: 'traffic_type', label: 'Тип Трафика', type: 'link'},
  {value: 'traffic_source', label: 'Источник', type: 'link'},
  {value: 'bot', label: 'Бот', type: 'link'},
  {value: 'channel', label: 'Канал', type: 'link'},
  {value: 'tg_account', label: 'Телеграм Аккаунт', type: 'link'},
  {value: 'channel_group', label: 'Группа Каналов', type: 'link'},
];

export const fieldsOfGroupsInf = [
  {
    value: 'offer',
    label: 'Оффер',
    type: 'link',
    rout: '/advertisers/offers/',
    isEditLink: '/advertisers/offers/updateOffer',
    isEdit: false,
    edit: '/advertisers/offers/',
  },
  {value: 'day', label: 'День', type: 'link'},
  {value: 'month', label: 'Месяц', type: 'link'},
  {value: 'year', label: 'Год', type: 'link'},
  {
    value: 'advertiser',
    label: 'Рекламодатель',
    type: 'link',
    rout: '/advertisers/list/',
    isEdit: false,
    isEditLink: '/advertisers/update',
    edit: '/advertisers/list/',
  },
  {value: 'brand', label: 'Бренд', type: 'link', isEdit: true, edit: '/advertisers/brands/'},
  {value: 'country', label: 'Страна', type: 'link'},
  {value: 'pwa', label: 'Приложение', type: 'link', rout: '/app/', isTimeConfig: true},
  {value: 'app', label: 'Приложение', type: 'link', rout: '/app/', isTimeConfig: true},
  {value: 'inf_bayer', label: 'Байер', type: 'link', rout: '/tracker/infuence/bayers/'},
  {value: 'landing', label: 'Лендинг', type: 'link'},
  {value: 'app_type', label: 'Платформа', type: 'link', isNotSorted: true},
  {
    value: 'inf_source',
    label: 'Поток',
    type: 'link',
    rout: '/tracker/influence/advertising/',
  },
  {
    value: 'inf_traffic',
    label: 'Блогер',
    type: 'link',
    rout: '/tracker/influence/bloggers/',
    isFilter: true,
    isTimeConfig: true,
  },
  {value: 'app_service', label: 'Сервис', type: 'link'},
  {value: 'traffic_type', label: 'Тип Трафика', type: 'link'},
  {value: 'traffic_source', label: 'Источник', type: 'link'},
  {value: 'bot', label: 'Бот', type: 'link'},
  {value: 'channel', label: 'Канал', type: 'link'},
  {value: 'tg_account', label: 'Телеграм Аккаунт', type: 'link'},
  {value: 'channel_group', label: 'Группа Каналов', type: 'link'},
];
